module.exports = __webpack_public_path__ + "img/google-message.3d152f49.webp";